export default {
  'quotations.request': 'Quotation Request',
};
